import React from "react"
import ControlButtonStandard, {
    ControlButtonType,
} from "../../../gd-components/buttons/control-button/control-button-standard"
import FieldCopyContent_ActionClick from "../../../fields3/generic/copy-content/actions/copy-click"
import FieldProto from "../../../fields3/proto/field-proto"

type Props = {
    field : FieldProto
    value : string
}

/**
 * The Copy button drawn inside the Secret input.
 *
 * Same as the stock FieldType.COPY_CONTENT button minus `hover-bg` - that class
 * paints the button's background at rest, not on hover, which reads as a chip
 * on the read-only fields it was written for and as noise on an editable one.
 */
export default function WebhookSecretCopyButton(props: Props) {

    const onClick = () => FieldCopyContent_ActionClick(props.field.label, props.value)

    return <ControlButtonStandard type    = {ControlButtonType.COPY}
                                  hint    = "Copy"
                                  onClick = {onClick}/>
}
